// Styles
import css from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={css.footer}>
      <p className={css.footerText}>Copyright © 2025-2035 Skiff Systems</p>
    </footer>
  );
};

export default Footer;
